import { render } from "./UpdateSitePlanCarbonTrackerComponent.vue?vue&type=template&id=48f679c0"
import script from "./UpdateSitePlanCarbonTrackerComponent.vue?vue&type=script&lang=js"
export * from "./UpdateSitePlanCarbonTrackerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__